export default __webpack_public_path__ + "static/media/cotton-candy.c5557c2e.svg";